import React from "react";
import { SetStateAction } from "react";
import { BlogsSocialMediaIcons } from "app-v2";

interface props {
  singlePost?: any;
  currDate?: string;
  categoryName?: string;
  showCopiedPopup: boolean;
  setShowCopiedPopup: React.Dispatch<SetStateAction<boolean>>;
}

export const BlogDetailsHeadingComponent = ({
  singlePost,
  currDate,
  categoryName,
  showCopiedPopup,
  setShowCopiedPopup,
}: props) => {
  return (
    <>
      {/* Author and DATE */}
      <div className="flex justify-start items-center align-middle ">
        {" "}
        <span className="font-openSans font-normal text-mobile-body-md lg:text-[20px] leading-5 lg:leading-6 text-brand-textLightGrey">
          {currDate}
        </span>
        <p className="font-openSans font-normal text-mobile-body-sm lg:text-web-body-lg leading-4 lg:leading-6 text-brand-bgBlack ml-2 lg:ml-4">
          by{" "}
          <span>
            {singlePost[0]?.attributes?.author?.data?.attributes?.name}
          </span>{" "}
          in <span> Auctions</span>
        </p>
      </div>
      {/* Heading and Icon */}
      <div className="flex  justify-start  col-span-4 mt-2.5">
        <div className="flex flex-col justify-start align-middle w-full">
          <p className="font-spaceGrotesk font-normal text-mobile-h1 lg:text-[56px] leading-[38px] lg:leading-[72px] text-brand-bgBlack">
            {singlePost[0]?.attributes?.title}
          </p>

          <div className="flex mt-2.5 lg:mt-[18px]">
            <p className="text-brand-bgBlack capitalize pl-2 pr-6 py-[5px] lg:leading-5 text-[11px] leading-[15px] lg:text-web-body-md font-semibold font-openSans bg-brand-lightBlue clip-path-topRightFourSidedBlogs">
              {categoryName}
            </p>
          </div>
          <div className="flex justify-start flex-wrap items-center">
            {showCopiedPopup && (
              <div
                className={
                  "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 h-fit w-fit py-2 px-8 border border-white rounded-lg bg-black text-center text-white transition-all " +
                  (showCopiedPopup ? "opacity-100" : "opacity-0")
                }
              >
                Copied to Clipboard
              </div>
            )}
            <BlogsSocialMediaIcons
              setShowCopiedPopup={setShowCopiedPopup}
              showCopiedPopup={showCopiedPopup}
              className="mt-3 lg:mt-8"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetailsHeadingComponent;
